//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[[0,"AcquisitionMethod",1,0],[0,"CiId",1,0],[0,"Name",0,0],[0,"NumChildren",0,0],[0,"Parent",0,"CAM.ObjectProperty",0],[0,"QualifiedName",0,0],[0,"Value",1,0]],[[[],"Dispose",{},0,0],[["numChildren"],"GetChildren",{R_:{children:"CAM.ObjectProperty[]"}},0,0],[["node"],"Insert",{},1,0]],[]];
SPLM.CAM.ObjectProperty = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ObjectProperty";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ObjectProperty.AcquisitionMethods = Object.freeze({
    "None" : "None", "Direct" : "Direct", "CustomizableItem" : "CustomizableItem"});

export default SPLM;